<template>
	<!--  :title="isVideo ? '上传视频文件' : '上传文件'" -->
    <el-dialog
        :append-to-body="isFlag"
        :visible.sync="uploadDialogVisible"
        width="460px"
        center
        :before-close="cancel"
    >
	<div class="" slot="title" style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;margin-bottom: 10px;">
		{{isVideo ? '上传视频文件' : '上传文件'}}
	</div>
        <template v-if="!isVideo">
            <el-upload
                ref="upload"
                class="upload-demo"
                drag
                :action="actions"
                :accept="isAccept ? '*' : '.xls,.xlsx'"
                :limit="1"
                :on-change="onChange"
                :before-upload="beforeUpload"
            >
                <i class="el-icon-upload" style="color: #D6E4FD;font-size:120px;"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip" v-if="!isAccept">注意只能上传<strong>.xls/xlsx</strong>文件</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="submitting" :disabled="submitting" @click="sureUpload">确 定</el-button>
            </span>
        </template>
        <template v-else>
            <div class="video-upload">
                <input type="file" name="file" value="视频上传" id="file" ref="file" />
                <!-- 上传进度 -->
                <Progress :isShow="isShow" :percentage="percentage" />
                <div class="btns">
                    <el-button style="width: 120px;" @click="cancel">取 消</el-button>
					<!-- style="background:#de4d2a !important" -->
                    <el-button style="width: 120px;" class="upload" :disabled="disabled" @click="upload" type="primary">上传</el-button>
                </div>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import global from 'global';
import md5 from '@/utils/md5';
import bus from '@/utils/bus';
import Progress from '@/components/progress';
import { beforeUploadEnd, beforeUploadStart, beforeUploading } from '@/serve/userGrouping';
export default {
    props: {
        uploadDialogVisible: Boolean,
        isAccept: {
            type: Boolean,
            default: false
        },
        isFlag: {
            type: Boolean,
            default: false
        },
        isFileCheck: {
            type: Boolean,
            default: true
        },
        isVideo: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Progress
    },
    computed: {
        actions() {
			// return 'https://live.pochanyun.net/api/sys/fs/';
			return '/api/sys/fs/';
        }
    },
    mounted() {
        bus.$on('clear', () => {
            this.$refs.upload && this.$refs.upload.clearFiles && this.$refs.upload.clearFiles();
        });
    },
    data() {
        return {
            disabled: false,
            blob: '',
            fileId: '',
            fileName: '',
            format: '',
            filesize: '',
            // sectionSize: 20971520,
            // sectionSize: 52428800,
            sectionSize: 1048576,
            uploadId: '',
            ids: [],
            start: 0,
            end: 0,
            fileMd5: '',
            mimeType: '',
            partIds: [],
            percentage: 0,
            isShow: false,
            submitting: false,
            lastSubmitTime: 0
        };
    },
    methods: {
        canSubmit() {
            const now = Date.now();
            if (this.submitting || (this.lastSubmitTime && now - this.lastSubmitTime < 1000)) {
                return false;
            }
            this.lastSubmitTime = now;
            this.submitting = true;
            return true;
        },
        resetSubmitState() {
            this.submitting = false;
        },
        // 视频上传
        upload() {
            if (!this.canSubmit()) {
                return;
            }
            this.disabled = true;
            this.blob = this.$refs.file.files[0];
            if (!this.blob) {
                this.resetSubmitState();
                this.disabled = false;
                return this.$message.error('请先选择视频文件');
            }
            this.filesize = this.blob.size;
            this.fileName = this.blob.name;
            this.mimeType = this.blob.type;
           /*  if (this.filesize < this.sectionSize) {
                if (this.filesize < 10485760) {
                    this.sectionSize = 1048576;
                } else {
                    // this.sectionSize = 10485760;
                    this.sectionSize = 1048576;
                }
            } */
            md5(this.blob, this.sectionSize)
                .then(e => {
                    this.fileMd5 = e;
                    this.uploadVideoStart();
                })
                .catch(() => {
                    this.resetSubmitState();
                    this.disabled = false;
                    this.$message.error('MD5计算失败');
                });
        },
        cancel() {
            this.$refs.upload.clearFiles();
            // document.selection.clear();
            this.isShow = this.disabled = false;
            this.resetSubmitState();
            this.lastSubmitTime = 0;
            this.$emit('cancel');
        },
        submitUpload(file, fileList) {
            this.$refs.upload.submit();
        },
        // 视频分片上传前
        uploadVideoStart() {
            beforeUploadStart({ md5: this.fileMd5, size: this.filesize })
                .then(res => {
                    if (res.exist) {
                        this.$emit('sureUpload', res.doc.id, res.doc.name, 'VIDEO');
                        this.disabled = false;
                        this.resetSubmitState();
                        return;
                    }
                    this.uploadId = res.uploadId;
                    this.isShow = true;
                    this.sliceRecursion();
                })
                .catch(err => {
                    this.disabled = false;
                    this.resetSubmitState();
                    this.$message.error(err.data.message);
                });
        },
        // 递归循环切片上传
        sliceRecursion() {
            if (this.start < this.filesize) {
                this.end = this.start + this.sectionSize;
                if (this.end > this.filesize) {
                    this.end = this.filesize;
                }
                // 上传进度
                this.percentage = parseInt((100 * this.start) / this.filesize);
                //计算文件切片总数
                let totalPieces = Math.ceil(this.filesize / this.sectionSize);
                let chunk = this.blob.slice(this.start, this.end);
                let formData = new FormData();
                formData.append('data', chunk, this.fileName);
                formData.append('uploadId', this.uploadId);
                formData.append('size', chunk.size);
                this.uploadVideoing(formData);
            } else {
                beforeUploadEnd({
                    md5: this.fileMd5,
                    name: this.fileName,
                    size: this.filesize,
                    uploadId: this.uploadId,
                    mimeType: this.mimeType,
                    partIds: this.partIds
                }).then(res => {
                    this.percentage = 100;
                    this.isShow = false;
                    this.disabled = false;
                    this.resetSubmitState();
                    this.$emit('sureUpload', res.id, res.name, 'VIDEO');
                });
            }
        },
        // 视频上传中
        uploadVideoing(formData) {
            beforeUploading(formData)
                .then(res => {
                    this.start = this.end;
                    this.partIds.push(res.partId);
                    this.sliceRecursion();
                })
                .catch(err => {
                    this.disabled = false;
                    this.resetSubmitState();
                    this.$message.error(err.data.message);
                });
        },
        onChange(file, fileList) {
            if (file.response && file.response.id) {
                this.fileId = file.response.id;
                this.fileName = file.response.name;
            }
        },
        // 文件上传之前检测格式
        beforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (!this.isFileCheck && !this.isAccept) {
                const extension = testmsg === 'xls';
                const extension2 = testmsg === 'xlsx';
                if (!extension && !extension2) {
                    this.$message({
                        message: '上传文件只能是 xls、xlsx格式!',
                        type: 'warning'
                    });
                    return false;
                }
                this.format = 'DOC';
                return extension || extension2;
            } else {
                if (testmsg === 'jpg' || testmsg === 'png' || testmsg === 'jpeg' || testmsg === 'gif') {
                    this.format = 'IMAGE';
                    return true;
                } else if (
                    testmsg === 'doc' ||
                    testmsg === 'txt' ||
                    testmsg === 'pdf' ||
                    testmsg === 'ppt' ||
                    testmsg === 'pptx' ||
                    testmsg === 'docx' ||
                    testmsg === 'xls' ||
                    testmsg === 'xlsx' ||
                    testmsg === 'zip'
                ) {
                    this.format = 'DOC';
                    return true;
                }
                this.format = 'DOC';
                return true;
            }
        },
        sureUpload() {
            if (!this.canSubmit()) {
                return;
            }
            if (!this.fileId) {
                this.resetSubmitState();
                return this.$message.warning('请先选择文件');
            }
            this.$emit('sureUpload', this.fileId, this.fileName, this.format);
            this.$refs.upload.clearFiles();
            setTimeout(() => {
                this.resetSubmitState();
            }, 1000);
        }
    }
};
</script>
<style scoped lang="scss">
.upload-demo {
    text-align: center;
    strong {
        margin: 0 5px;
    }
}
.video-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 0 20px;
    #file {
        margin-bottom: 20px;
    }
    .btns {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
